export const columns = [
  {
    accessorKey: "partyName",
    header: "Party Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "name",
    header: "Nomination Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "perCbm",
    header: "Per Cbm",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "perIndex",
    header: "Per Index",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "fuelCharges",
    header: "Fuel Charges",
    type: "number",
    flex: 1,
  },
  {
    accessorKey: "trackingCharges",
    header: "Tracking Charges",
    type: "number",
    flex: 1,
  },
  {
    accessorKey: "documentationCharges",
    header: "Documentation Charges Per Index",
    type: "number",
    flex: 1,
  },
  {
    accessorKey: "terminalHandlingCharges",
    header: "Terminal Handling Charges Per CBM",
    type: "number",
    flex: 1,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
